import React from "react";
import {
  Package,
  CheckedItem,
  Text,
  Button,
  Section,
  Divider,
} from "./PaymentPackage.styles";

interface Props {
  name: string;
  description: string;
  price: number;
  period: string;
  features: [];
  color: string;
  onPackageSelect: any
}

function PaymentPackage(props: Props) {
  const {} = props;

  return (
    <Package>
      <Section height="128px" align="center">
        <Text align="center" color={props.color} fontSize="36px">
          {props.name}
        </Text>
        <Text align="center" color="var(--white)" fontSize="18px">
          {props.description}
        </Text>
      </Section>

      <Section height="180px" align="center" justify="space-evenly">
        <Divider />
        <div>
          <Text align="center" color={props.color} fontSize="40px">
            &pound;{props.price.toFixed(2)}
            <Text
              style={{ marginTop: "-.5em" }}
              fontSize="24px"
              color="#3b3b3b"
            >
              {props.period}
            </Text>
          </Text>
        </div>
        <Divider />
      </Section>

      <Section height="260px">
        {props.features.map((item, i) => (
          <CheckedItem color={props.color} key={`feature-${i}`}>
            <i className="fa fa-check-circle-o" aria-hidden="true" />
            <span>{item}</span>
          </CheckedItem>
        ))}
      </Section>

      <Button onClick={props.onPackageSelect} background={props.color}>GET PERFORMANCE LEARNING</Button>
    </Package>
  );
}

export default PaymentPackage;



// WEBPACK FOOTER //
// ./src/components/PaymentPackage/PaymentPackage.tsx